module.exports = __webpack_public_path__ + "img/76.c47bcd3c.jpg";